import { render, staticRenderFns } from "./regist.vue?vue&type=template&id=9a67ae2e&scoped=true&"
import script from "./regist.vue?vue&type=script&lang=js&"
export * from "./regist.vue?vue&type=script&lang=js&"
import style0 from "./regist.vue?vue&type=style&index=0&id=9a67ae2e&scoped=true&lang=scss&"
import style1 from "./regist.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a67ae2e",
  null
  
)

export default component.exports